// extracted by mini-css-extract-plugin
module.exports = {"root":"MultiRowSelect_root__D_z4F"};